// GENERATED by azure-function/scripts/sync-check-cis.mjs from the checks in controls.js. Do not edit by hand.
// CIS Controls v8 numbers per report topic.
export const CIS_REF_BY_TOPIC = {
  'device-access-control': '13.5',
  'device-admin-password': '4.7 · 5.2 · 5.4 · 6.8',
  'device-antimalware': '10.1',
  'device-app-control': '2.5',
  'device-auth': '4.1 · 4.3 · 4.10 · 5.2',
  'device-backup': '11.2',
  'device-edr': '13.2',
  'device-encryption': '3.3 · 3.6 · 3.9',
  'device-enrollment': '4.1 · 6.8',
  'device-firewall': '4.1 · 4.5',
  'device-patching': '7.3',
  'guest-admin-block': '6.1',
  'legacy-auth': '4.8 · 6.7 · 13.5',
  'location-access': '6.7 · 12.2',
  'mail-domain-auth': '9.5',
  'mail-phishing': '9.3 · 9.6 · 9.7 · 10.1',
  'mail-spam': '4.2',
  'mfa-admin': '6.5',
  'mfa-all': '6.3 · 8.11',
  'mfa-azure': '6.3',
  'mfa-guest': '6.4',
  'mobile-app-protection': '2.5 · 4.12',
  'session-control': '4.3',
};
